import {FormSubmitter} from './form.submitter';
import {FormTrigger} from './form.trigger';

export const FORM_DIRECTIVES = [
    FormTrigger,
    FormSubmitter
];

export * from './form.submitter';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/form/index.ts